// react/jsx-no-undef

import { formatDate, DATE_FORMAT } from "../../helpers/dateFormat";
import { enGB } from "date-fns/locale";
import { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

// Optional: `onRangeSelectionStep({ step, startDate, endDate, startDateFormatted, endDateFormatted })`
// — `start` after the first day is committed (end is initialised to that day); `end` after the end day is committed.
// `isPopoverOpen`: when it flips to true, focus tracking resets (popover opened).

const RangePicker = ({
  onStatusChange,
  onRangeSelectionStep,
  isPopoverOpen,
}) => {
  const [state, setState] = useState([
    {
      startDate: undefined,
      endDate: undefined,
      key: "selection",
    },
  ]);
  const [focusedRange, setFocusedRange] = useState([0, 0]);
  const prevFocusRef = useRef([0, 0]);
  const lastSelectionRef = useRef({ startDate: undefined, endDate: undefined });
  const wasPopoverOpenRef = useRef(false);

  useEffect(() => {
    if (isPopoverOpen === undefined) return;
    if (isPopoverOpen && !wasPopoverOpenRef.current) {
      setFocusedRange([0, 0]);
      prevFocusRef.current = [0, 0];
    }
    wasPopoverOpenRef.current = isPopoverOpen;
  }, [isPopoverOpen]);

  const emitStepIfNeeded = (prev, next) => {
    if (!onRangeSelectionStep) return;
    const { startDate, endDate } = lastSelectionRef.current;
    if (!startDate || !endDate) return;
    const startDateFormatted = formatDate(startDate, DATE_FORMAT.DISPLAY);
    const endDateFormatted = formatDate(endDate, DATE_FORMAT.DISPLAY);
    const detail = {
      startDate,
      endDate,
      startDateFormatted,
      endDateFormatted,
    };
    if (prev[0] === next[0] && prev[1] === 0 && next[1] === 1) {
      onRangeSelectionStep({ step: "start", ...detail });
    } else if (prev[0] === next[0] && prev[1] === 1 && next[1] === 0) {
      onRangeSelectionStep({ step: "end", ...detail });
      onStatusChange((prev) => ({
        ...prev,
        startDate: formatDate(startDate, DATE_FORMAT.DISPLAY),
        endDate: formatDate(endDate, DATE_FORMAT.DISPLAY),
      }));
    }
  };

  const handleRangeFocusChange = (next) => {
    const prev = prevFocusRef.current;
    emitStepIfNeeded(prev, next);
    prevFocusRef.current = next;
    setFocusedRange(next);
  };

  return (
    <DateRangePicker
      focusedRange={focusedRange}
      onRangeFocusChange={handleRangeFocusChange}
      onChange={(item) => {
        const { startDate, endDate } = item.selection;
        if (!startDate || !endDate) return;
        lastSelectionRef.current = { startDate, endDate };
        setState([item.selection]);

      }}
      ranges={state}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      months={2}
      direction="horizontal"
      preventSnapRefocus={true}
      calendarFocus="backwards"
      locale={enGB}
    />
  );
};

export default RangePicker;
